// extracted by mini-css-extract-plugin
export default {"error":"Text_error__lYNTB","root":"Text_root__MmCQN","box":"Text_box__Wp9Cc"};